import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'

import { MapService } from '../providers/mapService'
import {BCanvasLayer, CanvasLayerOptions} from "../types/CanvasLayer";

@Directive({
  selector: 'canvaslayer'
})
export class CanvasLayderComponent implements OnInit, OnDestroy {
  @Input() private options: CanvasLayerOptions

  @Output() private loaded = new EventEmitter()

  private canvaslayer: BCanvasLayer

  constructor(private _service: MapService) {}

  public ngOnInit() {

    this._service
      .addCanvasLayer(() => {
        this.canvaslayer = new window.BMap.CanvasLayer(this.options)

        return this.canvaslayer
      })
      .then(() => {
        this.loaded.emit(this.canvaslayer)
      })
  }

  public ngOnDestroy() {
    this._service.removeCanvasLayer(this.canvaslayer)
  }
}
